var current_age_group = 'adult';
var current_gender = 'female';
var current_orientation = 'front';
var current_secondary_orientation = 'front';
var current_body_part = '';
var current_body_part_id = '';
var current_body_part_selector = '';

// This gets set to true if the user is manually switching the orientation.
var user_switching_orientation = false;

var use_transitions = true;
if (jQuery(document).width() < 800) {
  use_transitions = false;
}

jQuery(document).ready(function () {


  if (jQuery('.sc-finder').length > 0) {

    // Set defaults.
    if (vars.gender != undefined && vars.gender != '') {
      current_gender = vars.gender;
    }
    else {
      current_gender = 'female';
    }
    if (vars.age_group != undefined && vars.age_group != '') {
      current_age_group = vars.age;
    }
    else {
      current_age_group = 'adult';
    }

    current_age_group = jQuery('#default_age_group').val();
    current_gender = jQuery('#default_gender').val();
    current_body_part_id = jQuery('#default_body_part').val();

    if (current_body_part_id > 0) {
      var default_body_part_object = jQuery('.body-parts, .body-parts-sub').find('a[data-body-part-slug=' + current_body_part_id + ']');
      if (default_body_part_object !== 'undefined') {
        current_body_part_selector = default_body_part_object.attr('data-selector-id');
        current_body_part = default_body_part_object.attr('data-body-part-name');
      }
    }

    // Load a body.
    load_body();

    // Switch body
    jQuery('#age_group a').on('click touchend', function (e) {
      // Set new age group
      if (jQuery(this).attr('data-age-group') != current_age_group) {
        current_age_group = jQuery(this).attr('data-age-group');
        load_body()
      }
      e.preventDefault();
      //return false;
    });

    // Switch gender
    jQuery('#gender a').on('click touchend', function () {
      // Set new age group
      if (jQuery(this).attr('data-gender') != current_gender) {
        current_gender = jQuery(this).attr('data-gender'); 
        load_body()
      }
      return false;
    });

    // Switch orientation
    jQuery('#orientation a').off();
    jQuery('#orientation a').on('click touchend', function () {
      // Set new age group
      if (jQuery(this).attr('data-orientation') != current_orientation) {
        current_orientation = jQuery(this).attr('data-orientation');
        user_switching_orientation = true;
        load_body();
      }
      return false;
    });

    // Select body part
    jQuery('.main-parts a').on('click touchend', function () {
      scf_body_parts_select(jQuery(this));
      //console.log('CLicked main part');
      return false;
    });



    // List modal window
    jQuery('#list-parts').on('click touchend', function () {
      // Open this modal
      jQuery('#modal-main').modal([]);
      jQuery('#modal-main').modal('show');
      return false;
    });



    // Select sub body part
    jQuery('.body-parts-sub a').on('click touchend', function () {
      scf_body_parts_sub_select(jQuery(this));
      return false;
    });



    // Submit button
    jQuery('#scf-submit').on('click touchend', function () {
      //console.log('Age: ' + current_age_group);
      //console.log('Gender: ' + current_gender);
      //console.log('Body part: ' + current_body_part_id);
      if (current_age_group == '' || current_gender == '' || current_body_part_id == '') {
        return false;
      }

      var url = '/skin-conditions-search/?_age=' + current_age_group + '&_gender=' + current_gender + '&_body_part=' + current_body_part_id;

      // Direct this request to the skin condition search
      window.location.href = url;
      return false;
    });
  }
});

var parts_loading;
var parts_loaded;
function load_body() {

  //jQuery('.select-body-part-container').prepend('Inside load_body();');

  parts_loading = 4;
  parts_loaded = 0;
  jQuery('#sc-body').addClass('loading');
  jQuery('#loader-body').removeClass('hide');
  jQuery('#loader-body').removeClass('hiding');
  jQuery('#sc-body').addClass('no-transition');

  if (use_transitions) {
    setTimeout(function () {
      jQuery('#sc-body').addClass('loading');
    }, 10);
  }
  else {
    jQuery('#sc-body').addClass('loading');
  }

  var svg_url = '';
  var age_group_str = '';
  var gender_str = '';

  var age_group = current_age_group;
  var gender = current_gender;
  var orientation = current_orientation;

  var name_part = age_group + '_' + gender;
  if (age_group == 'infant') {
    name_part = age_group;
  }

  if (orientation == 'front') {
    svg_url = vars[name_part];
  }
  else {
    svg_url = vars[name_part + '_back'];
  }

  var svg_face_url = vars[name_part + '_face'];

  var svg_hand_front = '';
  var svg_hand_back = '';
  var svg_foot_front = '';
  var svg_foot_back = '';
  if (age_group == 'infant') {
    svg_hand_front = vars['infant_hand'];
    svg_hand_back = vars['infant_hand_back'];
    svg_foot_front = vars['infant_foot'];
    svg_foot_back = vars['infant_foot_back'];
  }
  else {
    svg_hand_front = vars['shared_hand'];
    svg_hand_back = vars['shared_hand_back'];
    svg_foot_front = vars['shared_foot'];
    svg_foot_back = vars['shared_foot_back'];
  }

  if (current_secondary_orientation == 'front') {
    var svg_hand_url = svg_hand_front;
    var svg_foot_url = svg_foot_front;
  }
  else {
    var svg_hand_url = svg_hand_back;
    var svg_foot_url = svg_foot_back;
  }

  //console.log(current_age_group + current_gender);

  // Select the age group buttons
  jQuery('#age_group a').removeClass('selected');
  jQuery('#age_group').find('a[data-age-group='+current_age_group+']').addClass('selected');

  // Select the gender buttons
  jQuery('#gender a').removeClass('selected');
  jQuery('#gender').find('a[data-gender=' + current_gender + ']').addClass('selected');
  
  // Select the gender buttons
  jQuery('#orientation a').removeClass('selected');
  jQuery('#orientation').find('a[data-orientation='+current_orientation+']').addClass('selected');

  
  update_selected();

  // Update the body
  xhr = new XMLHttpRequest();
  xhr.open("GET",svg_url,false);
  xhr.overrideMimeType("image/svg+xml");
  xhr.onload = function(e) {
    jQuery('#sc-body').html(xhr.responseXML.documentElement);

    if (use_transitions) {
      setTimeout(function () {
        // Remove loader.
        jQuery('#sc-body').removeClass('no-transition');
        setTimeout(function () {
          jQuery('#loader-body').addClass('hiding');
          setTimeout(function() {
            jQuery('#loader-body').addClass('hide');
            jQuery('#sc-body').removeClass('loading');
          }, 100);
        }, 10);
      }, 10);
    }
    else {
         // Remove loader.
         jQuery('#sc-body').removeClass('no-transition');
         jQuery('#loader-body').addClass('hiding');
         jQuery('#loader-body').addClass('hide');
         jQuery('#sc-body').removeClass('loading');
    }
      
    parts_loaded++;
  }
  xhr.send("");

  // Update the face
  xhr = new XMLHttpRequest();
  xhr.open("GET",svg_face_url,false);
  xhr.overrideMimeType("image/svg+xml");
  xhr.onload = function (e) {
    jQuery('#sc-face').html(xhr.responseXML.documentElement);

    // Remove loader.
    jQuery('#sc-face').removeClass('loading');
    jQuery('#loader-face').addClass('hide');
    parts_loaded++;
  }
  xhr.send("");

  // Update the hand
  xhr = new XMLHttpRequest();
  xhr.open("GET",svg_hand_url,false);
  xhr.overrideMimeType("image/svg+xml");
  xhr.onload = function(e) {
    jQuery('#sc-hand').html(xhr.responseXML.documentElement);

    // Remove loader.
    jQuery('#sc-hand').removeClass('loading');
    jQuery('#loader-hand').addClass('hide');
    parts_loaded++;
  }
  xhr.send("");

  // Update the foot
  xhr = new XMLHttpRequest();
  xhr.open("GET",svg_foot_url,false);
  xhr.overrideMimeType("image/svg+xml");
  xhr.onload = function(e) {
    jQuery('#sc-foot').html(xhr.responseXML.documentElement);

    // Remove loader.
    jQuery('#sc-foot').removeClass('loading');
    jQuery('#loader-foot').addClass('hide');
    parts_loaded++;
  }
  xhr.send("");


  load_body_complete();
  
}


function load_body_complete() {
  
  if (parts_loading == parts_loaded) {

    load_body_events();
    jQuery('.main-parts a').removeClass('selected');
    if (current_body_part_selector != '') {
      jQuery('.main-parts').find('a[data-selector-id=' + current_body_part_selector + ']').addClass('selected');
      select_body_part(current_body_part_selector);
    }
    update_image_selection();

    // Load what is selected
    if (current_body_part_id != '') {
      var default_body_part_object = jQuery('.main-parts').find('a[data-body-part-slug=' + current_body_part_id + ']');
      //console.log('Body part obj: ' + default_body_part_object.attr('data-body-part-slug'));
      if (default_body_part_object !== undefined && default_body_part_object.attr('data-body-part-slug') !== undefined) {
        scf_body_parts_select(default_body_part_object);
      }
      else {
        default_body_part_object = jQuery('.body-parts-sub').find('a[data-body-part-slug=' + current_body_part_id + ']');
        scf_body_parts_sub_select(default_body_part_object);
      }
    }

  }
  else {
    setTimeout(load_body_complete, 200); // try again in 300 milliseconds
  }

}

function load_body_events() {
  
  // Kill the links.
  jQuery('#sc-body a').on('click', function () {
    return false;
  });
    
  // Select body part
  jQuery('#sc-body svg a:not(#widespreadrash, #widespreadRash)').off();
  jQuery('#sc-body svg a:not(#widespreadrash, #widespreadRash)').on('click touchend', function (e) {
    //console.log('Clicked ID: ' + jQuery(this).attr('id'));
    scf_click_body_part(jQuery(this).attr('id'));
    return false;
  });
  //jQuery('#sc-body svg a:not(#widespreadrash)').bind('tap', function () {
  //  scf_click_body_part(jQuery(this).attr('id'));
  //});

  jQuery('.sc-body:not(#sc-body) svg a').off();

  // Sub parts
  jQuery('.sc-body:not(#sc-body) svg a').on('click touchend', function () {

    // Remove selections on all sub body parts.
    jQuery('.sc-body a').removeClass('selected');
    // Unselect other selectors?
    jQuery('.body-parts-sub a').removeClass('selected');
    
    // Grab the selected ID and map it to its proper ID.
    var part_selected = jQuery(this).attr('id');
    
    // Set the currently selected body part
    current_body_part_selector = part_selected;
    current_body_part_id = part_selected;

    // Find the sub part we're selecting in.
    jQuery('.body-parts-sub a[data-selector-id=' + part_selected + ']').addClass('selected');

    if (part_selected != '') {
      // We need to actually get the body part name here, not just this ID.
      var this_sub_body_part = jQuery('.body-parts-sub').find('a[data-selector-id=' + part_selected + ']');

      // Use the name and not the slug.
      if (this_sub_body_part) {
        current_body_part = this_sub_body_part.attr('data-body-part-name');
        current_body_part_selector = this_sub_body_part.attr('data-body-part-slug');
        current_body_part_id = this_sub_body_part.attr('data-body-part-slug');
      }
      // If for some strange reason we can't find the name, just show the slug.
      else {
        current_body_part = jQuery('.body-parts-sub a[data-selector-id=' + part_selected + ']').attr('data-body-part-slug');
      }
    }

    update_selected();

    // Select this on our person.
    jQuery(this).addClass('selected');
    
    return false;
  });
}

function update_image_selection() {
  
  // Unselect entire body
  jQuery('#sc-body svg *').removeClass('selected');

  // Select this on our person.
  if (current_body_part_selector != '') {
    jQuery('#sc-body #' + current_body_part_selector).addClass('selected');
  }
  
}

function select_body_part(selector_id) {
  jQuery('.main-parts a').removeClass('selected');
  jQuery('.main-parts').find('a[data-selector-id=' + selector_id + ']').addClass('selected');

  //console.log('selecting ' + selector_id);

  // Unselect entire body
  jQuery('#sc-body svg *').removeClass('selected');

  // Select this on our person.
  jQuery('#sc-body #' + selector_id).addClass('selected');
}

function update_selected() {
  
  var age_group_str = '';
  var gender_str = '';
  var body_part_str = '';

  // Determine gender
  if (current_gender == 'male') {
    gender_str = 'Male';
  }
  else if (current_gender == 'female') {
    gender_str = 'Female';
  }

  // Determine age goup
  if (current_age_group == 'adult') {
    age_group_str = 'Adult';
  }
  else if (current_age_group == 'teen') {
    age_group_str = 'Teen';
  }
  else if (current_age_group == 'child') {
    age_group_str = 'Child';
  }
  else if (current_age_group == 'infant') {
    age_group_str = 'Infant';
  }

  // Determine body part
  if (current_body_part != '') {
    body_part_str = current_body_part;
    //body_part_str = current_body_part.charAt(0).toUpperCase() + current_body_part.slice(1);
  }
  // Updated selected.
  jQuery('#scf-selected').html('');
  if (age_group_str != '') {
    jQuery('#scf-selected').append('<span>'+age_group_str+'</span>');
  }
  if (gender_str != '') {
    jQuery('#scf-selected').append('<span>'+gender_str+'</span>');
  }
  if (body_part_str != '') {
    jQuery('#scf-selected').append('<span>'+body_part_str+'</span>');
  }

  update_submit_button();
}


function update_submit_button() {

  if (current_age_group == '' || current_gender == '' || current_body_part_id == '') {
    if (!jQuery('#scf-submit').hasClass('disabled')) {
      jQuery('#scf-submit').addClass('disabled')
    }
  }
  else {
    jQuery('#scf-submit').removeClass('disabled')
  }
  
}




// Front page lead in
jQuery(document).ready(function () {
  scf_intro_form_valid_check();

  jQuery('#scf-intro select, #scf-intro input').on('change', function () {
    scf_intro_form_valid_check();
  });


});

function scf_intro_form_valid_check() {

  //console.log(jQuery('#scf-intro select#scf-age'));

  if (jQuery('#scf-intro select#scf-age').val() != ''
  && jQuery('#scf-intro input[name=gender]:checked').val()
  ) {
    jQuery('#scf-continue').addClass('active');
  }

}



function scf_body_parts_sub_select(element) {
  var selector_id = element.attr('data-selector-id');

  // Get the selector ID
  var body_part_sub = element.closest('.body-parts-sub');
  var sub_type = body_part_sub.attr('data-id-selector');

  current_body_part = element.attr('data-body-part-name');
  current_body_part_selector = element.attr('data-selector-id');
  current_body_part_id = element.attr('data-body-part-slug');

  // Don't flip the orientation automatically if the user just manually flipped it.
  if (element.attr('data-orientation') != current_secondary_orientation && !user_switching_orientation) {
    current_secondary_orientation = element.attr('data-orientation');
    load_body();
    user_switching_orientation = false;
  }

  jQuery('.body-parts-sub a').removeClass('selected');
  body_part_sub.find('a[data-selector-id=' + selector_id + ']').addClass('selected');

  // Unselect entire body
  jQuery('.sc-body-secondary[data-id-selector=' + sub_type + '] svg *').removeClass('selected');

  // Select this on our person.
  jQuery('.sc-body[data-id-selector=' + sub_type + '] svg #' + selector_id + ' *').addClass('selected');
  jQuery('.sc-body[data-id-selector=' + sub_type + '] svg #' + selector_id).addClass('selected');

  update_selected();
  
  // Make sure we select the parent body part, just for aesthetic.
  var parent_selector = element.closest('.body-parts-sub').attr('data-id-selector');
  if (parent_selector) {
    select_body_part(parent_selector);
  }

}

function scf_body_parts_select(element) {
      current_body_part = element.attr('data-body-part-name');
      current_body_part_selector = element.attr('data-selector-id');
      current_body_part_id = element.attr('data-body-part-slug');

      // Load modal?
      var modal_id = element.attr('data-modal-id');
      if (modal_id != null) {
        // Close all other modal windows.
        jQuery('.modal').modal('hide');
        // Open this modal

        if (use_transitions) {
          setTimeout(function () {
            jQuery('#' + modal_id).modal([]);
            jQuery('#' + modal_id).modal('show');
          }, 100);
        }
        else {
          jQuery('#' + modal_id).modal([]);
            jQuery('#' + modal_id).modal('show');
        }
      }

      // If we're selecting a part that is not on the current orientation, we need to switch.
      // We don't want to switch orientation back if the user just switched it, though.
      var new_orientation = element.attr('data-orientation');
      if (new_orientation != current_orientation && !user_switching_orientation) {
        current_orientation = new_orientation; 
        load_body();
      }
      else {
        // Mark this as selected.
        select_body_part(current_body_part_selector);
      }
  
      update_selected();
  
      user_switching_orientation = false;
}


function scf_click_body_part(bp_selector) {
  
  // Find the menu item for this and update the current body part
  current_body_part_selector = bp_selector;
  if (current_body_part_selector != '') {
    current_body_part = jQuery('.main-parts a[data-selector-id=' + current_body_part_selector + ']').attr('data-body-part-name');
    current_body_part_id = current_body_part_selector;
  }

  // Load modal?
  var modal_id = jQuery('.main-parts a[data-selector-id=' + current_body_part_selector + ']').attr('data-modal-id');
  if (modal_id != null) {
    // Open this modal
    jQuery('#' + modal_id).modal([]);
    jQuery('#' + modal_id).modal('show');
  }

  // Mark this as selected.
  select_body_part(current_body_part_id);
  update_selected();
}



// If we are searching for a skin type, we need to read it from the 
// query string and save it to a cookie.
var paramsString = (new URL(document.location)).searchParams;
var searchParams = new URLSearchParams(paramsString);


if ( searchParams.has("s_skin_type") ) { 
  var s_skin_type = searchParams.get("s_skin_type");
  createCookie('s_skin_type', s_skin_type, 2)
}


// Search autocomplete.
jQuery(document).ready(function () {
  var substringMatcher = function (strs) {
    return function findMatches(q, cb) {
      var matches, substringRegex;

      // an array that will be populated with substring matches
      matches = [];

      // regex used to determine if a string contains the substring `q`
      substrRegex = new RegExp(q, 'i');

      // iterate through the pool of strings and for any string that
      // contains the substring `q`, add it to the `matches` array
      jQuery.each(strs, function (i, str) {
        if (substrRegex.test(str)) {
          matches.push(str);
        }
      });

      cb(matches);
    };
  };


  jQuery('.header .search-field.typeahead').typeahead({
    hint: true,
    highlight: true,
    minLength: 1
  },
    {
      name: 'ac_values',
      source: substringMatcher(ac_values)
    })
    .bind('.header typeahead:select', function (ev, selection) {
      jQuery(this).val(selection);
      jQuery(this).parents('form').submit();
    });
  
  
  
  jQuery('#slider-search .search-field.typeahead').typeahead(
    {
    hint: true,
    highlight: true,
    minLength: 1
  },
  {
    name: 'ac_values',
    source: substringMatcher(ac_values)
  })
  .bind('#slider-search typeahead:select', function (ev, selection) {
    jQuery(this).val(selection);
    jQuery(this).parents('form').submit();
  });


  // Load up their search preference for soc
  var s_skin_type = readCookie("s_skin_type");
  if (s_skin_type != '') {
    if ( s_skin_type == 'light' || s_skin_type == 'dark' ) {
      jQuery('select.skin-color-dropdown').val(s_skin_type);
    }
    else { 
      jQuery('select.skin-color-dropdown').val('all');
    }
    // If they want to show dark skin, let's update the search results.
    if ( s_skin_type == 'dark' ) {
      jQuery('.search-results .thumb.soc-thumb').css('display', 'block');
      jQuery('.search-results .thumb.thumb-has-soc').css('display', 'none');
    }
  }
  
});




// SOC image slider sort
function sc_sort_slides_by_color(swiper_sc, slider_class) {

  new_slide_html = '';

  // Check to see if they have a cookie set.
  var s_skin_type = readCookie("s_skin_type");
  if (s_skin_type != '') {

    // We need to reorder the photos.
    var preferred_skin_type_gallery = [];
    var other_gallery = [];
    var k = 0;
    var j = 0;
    jQuery('.' + slider_class + ' .swiper-wrapper .swiper-slide').each(function (i, obj) {

      if ( jQuery(this).attr('data-color') == s_skin_type ) {
        preferred_skin_type_gallery[j] = jQuery(this).prop('outerHTML');
        j++;
      }
      else { 
        other_gallery[k] = jQuery(this).prop('outerHTML');
        k++;
      }
    });

    if (preferred_skin_type_gallery.length > 0) { 
      for (var j = 0; j < preferred_skin_type_gallery.length; j++) { 
        new_slide_html += preferred_skin_type_gallery[j];
      }
    }

    if (other_gallery.length > 0) { 
      for (var k = 0; k < other_gallery.length; k++) { 
        new_slide_html += other_gallery[k];
      }
    }

    //console.log(preferred_skin_type_gallery);
    //console.log(other_gallery);

    // Replace
    jQuery('.' + slider_class + ' .swiper-wrapper').html(new_slide_html);
  }
}